import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { loadAndAssert } from '../authz/access.js';
import { Exam } from '../exam.js';

export const deleteExamMutation = registerMutation({
  operationName: 'deleteExamMutation',
  type: () => Boolean,
  params: [
    { name: 'examId', type: () => String },
    // The teacher's choice in the delete dialog: students keep the results released to them.
    { name: 'keepReleases', type: () => Boolean },
  ],
  resolve: (examId: string, keepReleases?: boolean) => async () => {
    await loadAndAssert(Exam, examId, 'delete', { _id: 1 });

    // Takes the conversation, submissions, jobs, files and — unless kept — released results with it (see
    // delete-cascade.ts). Imported here: this module also reaches the client bundle (sidebar.tsx), the cascade is
    // server only.
    const { deleteExamCascade } = await import('../utils/delete-cascade.js');
    await deleteExamCascade(examId, { keepReleases: keepReleases === true });

    return true;
  },
});
